import client from './rest/AdminClient';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const getTrips = () => client({
    method: 'GET',
    path: '/api/trips',
    params: {
        _: new Date().getTime(),
    },
});
const createTrip = trip => client({
    method: 'POST',
    path: '/api/trips',
    entity: JSON.stringify(trip),
});
const updateTrip = trip => client({
    method: 'PUT',
    path: `/api/trips/${trip._id}`,
    entity: JSON.stringify(trip),
});
const saveAndApplyTrip = (orderId, trip) => client({
    method: 'POST',
    path: '/api/trips/shipments',
    entity: JSON.stringify({
        orderId,
        trip,
    }),
});
const generateTrip = ({ name, orderId, shipments_staging, shipments, }) => client({
    method: 'POST',
    path: '/api/trips/generate',
    entity: JSON.stringify({
        name,
        orderId,
        shipments_staging,
        shipments,
    }),
});
const API = {
    getTrips() {
        getTrips().then((res) => {
            AdminServerActionCreators.getTripsSuccess(res.entity.trips);
        }, (err) => {
            AdminServerActionCreators.getTripsFail(err.entity);
        });
    },
    createTrip(trip) {
        createTrip(trip).then((res) => {
            AdminServerActionCreators.createTripSuccess(res.entity.trip);
        }, (err) => {
            AdminServerActionCreators.createTripFail(err.entity);
        });
    },
    updateTrip(trip) {
        updateTrip(trip).then((res) => {
            AdminServerActionCreators.updateTripSuccess(res.entity.trip);
        }, (err) => {
            AdminServerActionCreators.updateTripFail(err.entity);
        });
    },
    saveAndApplyTrip(orderId, trip) {
        saveAndApplyTrip(orderId, trip).then(res => AdminServerActionCreators.saveAndApplyTripSuccess(res.entity), err => AdminServerActionCreators.saveAndApplyTripFail(err.entity));
    },
    generateTrip({ name, orderId, shipments_staging, shipments, }) {
        generateTrip({
            name,
            orderId,
            shipments_staging,
            shipments,
        }).then(res => AdminServerActionCreators.generateTripSuccess(res.entity.trip), err => AdminServerActionCreators.generateTripFail(err.entity));
    },
};
AdminAppDispatcher.register((payload) => {
    const action = payload.action || {};
    const type = action.type;
    switch (type) {
        case ActionTypes.CREATE_TRIP_REQUEST:
            API.createTrip(action.trip);
            break;
        case ActionTypes.UPDATE_TRIP_REQUEST:
            API.updateTrip(action.trip);
            break;
        case ActionTypes.SAVE_AND_APPLY_TRIP_REQUEST:
            API.saveAndApplyTrip(action.orderId, action.trip);
            break;
        case ActionTypes.GENERATE_TRIP_REQUEST:
            API.generateTrip(getGenerateTripParams(action));
            break;
        case ActionTypes.GET_TRIPS_REQUEST:
            API.getTrips();
            break;
        default:
            break;
    }
});
function getGenerateTripParams(action) {
    const { orderId, shipments, shipments_staging, name, } = action;
    return {
        orderId,
        shipments,
        shipments_staging,
        name,
    };
}
export default API;
